// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ogRrJ"};
module.exports.__checksum = "6a245813ae2a"